module.exports = __webpack_public_path__ + "static/media/apple_podcasts.7e9770ee.jpg";